<template>
  <div class='sub-content'> <!-- 여기까지 page header 이하 수정해서 사용-->
     <div class='goods-grid'>
      <dx-data-grid ref='refRawMaterialGrid'
        :data-source='rawMaterialInfoList'
        :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
        :hover-state-enabled = "true" :allowColumnResizing = 'true'
        column-resizing-mode = 'widget' :allow-column-reordering = "true"
        :height='gridHeight' :row-alternation-enabled="true"
        :focused-row-enabled="true"
        :auto-navigate-to-focused-row="false"
        key-expr="품번"
        @toolbar-preparing='onToolbarPreparing'
      >
        <DxSearchPanel
          :visible="true"
          placeholder="검색..."
        />
        <DxExport
          :enabled="true"
          :file-name="stockTitle"
        />
        <DxFilterRow
          :visible="true"
          apply-filter="auto"
        />
        <DxColumnFixing :enabled="true"/>
        <DxColumn v-if="$store.getters.getGroupName !== null"
          :allowEditing='false'
          :caption="$store.getters.getGroupName"
          data-field="차종"
          sort-order='asc'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품번"
          data-field="품번"
          sort-order='asc'
        >
        </DxColumn>
        <DxColumn
          :allowEditing='true'
          caption="품명"
          data-field="품명"
          :visible='true'
        >
        </DxColumn>
        <DxColumn
          caption="재고현황"
          alignment='center'
        >
          <DxColumn
            :allowEditing='false'
            caption="창고 현재고"
            data-field="창고재고"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
          <DxColumn
            :allowEditing='false'
            caption="재공 현재고"
            data-field="현재공"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
          <DxColumn
            :allowEditing='false'
            caption="합계"
            :calculate-cell-value="calculateStcokAmount"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
        </DxColumn>
        <DxColumn
          :allowEditing='false'
          caption="금월 실사재공"
          data-field="보정재공"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="창고이월재고"
          data-field="이월창고재고"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="창고재고보정"
          data-field="창고재고보정"
          :visible='false'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="이월재공"
          data-field="이월재공"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='false'
          caption="재공보정"
          data-field="재공재고보정"
          :visible='false'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='true'
          caption="금월생산"
          data-field="생산실적"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='true'
          caption="금월납품"
          data-field="출고수량"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='true'
          caption="불량폐기납품"
          data-field="폐기수량"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <DxColumn
          :allowEditing='true'
          caption="금월재투입수량"
          data-field="반송재투입수량"
          :visible='true'
          format='#,##0'
          dataType="number"
        />
        <!-- <DxColumn
          caption="반송현황"
          alignment='center'
        >
          <DxColumn
            :allowEditing='true'
            caption="금월반송"
            data-field="반송불량수량"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
          <DxColumn
            :allowEditing='true'
            caption="폐기수량"
            data-field="반송폐기수량"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
          <DxColumn
            :allowEditing='true'
            caption="재투입수량"
            data-field="반송재투입수량"
            :visible='true'
            format='#,##0'
            dataType="number"
          />
        </DxColumn> -->
        <DxSummary>
          <DxTotalItem
            value-format='#,##0'
            column="품번"
            display-format="{0} (건)"
          />
        </DxSummary>
        <dx-paging :enabled="false"/>
        <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
        <dx-sorting mode="multiple"/>
      </dx-data-grid>
    </div>
    <loading :active.sync="isLoading" color='rgb(2, 110, 156)' loader='bars'></loading>
  </div> <!--sub-conten end-->

</template>

<script>
import Loading from 'vue-loading-overlay'
import AppLib from '../../../share/AppLib'
import ConstDef from '../../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxExport, DxColumnFixing, DxTotalItem,
  DxSummary, DxColumn, DxPaging, DxSorting, DxSearchPanel } from 'devextreme-vue/data-grid'

export default {
  name: 'login',
  data: function () {
    return {
      isLoading: false,
      userInfo: null,
      gridHeight: null,
      rawMaterialInfoList: null,
      stockTitle: null
    }
  },
  components: {
    Loading,
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxExport,
    DxColumnFixing,
    DxTotalItem,
    DxSummary,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel
  },
  props: {
    goodsCode: {
      type: String,
      default: null
    }
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
      return
    }
    this.refreshCurrentStock()
  },
  mounted () {
    this.gridHeight = (screen.height - 250) * 0.95
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calculateStcokAmount (row) {
      return row.창고재고 + row.현재공
    },
    onToolbarPreparing (e) {
      const baseDate = `${AppLib.calcMonthFromToday(0).substring(0, 7)}-01`
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;color:blue;'><b>이월기준일: ${baseDate}</b></div>`
          }
        }
      )
    },
    refreshCurrentStock () {
      console.log(this.goodsCode)
      this.stockTitle = `${AppLib.getToday()}_${this.goodsCode}`
      const param = {
        toDate: AppLib.calcDateFromToday(1),
        품목유형: ConstDef.다공정품,
        isTest: process.env.NODE_ENV === 'production' ? 0 : 1
      }
      this.isLoading = true
      // this.$_sp.runNoEncodeFindProc('spFindAllStockReceiptByToDateAndPtypeV2', param)
      this.$_sp.runNoEncodeFindProc('spFindAllThisMonthWip', param)
        .then((data) => {
          this.isLoading = false
          this.rawMaterialInfoList = this.$_sp.MakeModel(data)
          console.log(this.rawMaterialInfoList)
        })
        .catch(error => {
          this.isLoading = false
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
